import React from "react";
import SearchMovies from "./components/SearchMovies";
import logo from "./assets/tmdb_logo.svg";

function App() {
  return (
    <div className='container'>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1 className='title'>Movie App</h1>

        <img
          src={logo}
          alt='logo'
          style={{ width: "10em", position: "absolute", marginLeft: "2em" }}
        />
      </div>
      <SearchMovies />
    </div>
  );
}

export default App;
